<template>
	<c-dialog ref="dialog" width="860" height="520" enable-flex>
		<!-- 不合格的跳过并发布/下架其余，成功份数与失败明细同屏，避免用户以为全部没处理 -->
		<div class="m-result-summary flex">
			<p class="flex-grow">
				<span class="m-count-success">{{isUnpublish ? '已下架' : '已发布'}} {{publishCount}}份报告</span>
				<span class="m-count-fail">，{{blockCount}}份{{isUnpublish ? '未下架' : '未发布'}}</span>
			</p>
			<p v-if="blockCount > blockList.length" class="m-count-limit">仅展示前{{blockList.length}}份</p>
		</div>

		<div class="m-result-table-area flex-column flex-grow">
			<c-table ref="list" :data="blockList" height="grow" :paging="false" :empty-text="isUnpublish ? '没有未下架的记录' : '没有未发布的记录'">
				<c-table-column label="背贴码" name="produce_unique_code" width="120">
					<template #default="{data}">{{data.produce_unique_code || '-'}}</template>
				</c-table-column>
				<c-table-column label="报告端" width="90">
					<template #default="{data}">{{data.report_type_name || '-'}}</template>
				</c-table-column>
				<c-table-column :label="isUnpublish ? '未下架原因' : '未发布原因'" min-width="240">
					<template #default="{data}"><span class="m-reason">{{data.reason}}</span></template>
				</c-table-column>
			</c-table>
		</div>
		<template #button>
			<c-button size="dialog" color="main" @click="$refs.dialog.close()">知道了</c-button>
		</template>
	</c-dialog>
</template>

<script>
	export default {
		name: 'qualityPublishResult',

		data() {
			return {
				//操作类型：publish 发布 / unpublish 下架（批量弹框合并提交时由前端传入），文案随之切换
				opType: 'publish',
				publishCount: 0,
				/**后端返回的未发布/未下架总份数，可能大于已回传明细数（受回传上限约束）*/
				blockCount: 0,
				blockList: []
			}
		},

		computed: {
			isUnpublish() {
				return this.opType === 'unpublish';
			}
		},

		methods: {
			/*********打开弹框（只读明细页，入参为 batchPublish/batchUnpublish 返回的统计对象）**********/
			open(data) {
				var result = data || {};
				this.opType = result.op_type === 'unpublish' ? 'unpublish' : 'publish';
				this.publishCount = result.publish_count || 0;
				this.blockCount = result.block_count || 0;
				this.blockList = result.block_list || [];
				this.$refs.dialog.open({
					title: this.isUnpublish ? '质检报告下架失败明细' : '质检报告未发布明细'
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	::v-deep .c-dialog-body {
		padding: 0 12px;
	}

	.m-result-summary {
		padding: 12px 15px;
		margin-bottom: 12px;
		background: #f5f7fa;
		border-radius: 4px;
		font-size: 14px;
		gap: 12px;

		.m-count-success {
			color: #19be6b;
		}

		.m-count-fail {
			color: #ed3f14;
		}

		.m-count-limit {
			color: #909399;
			font-size: 13px;
		}
	}

	.m-result-table-area {
		margin: 0 20px 10px;
		border: 1px solid #e8e8e8;
		border-radius: 4px;
		overflow: hidden;

		.m-reason {
			color: #ed3f14;
		}
	}
</style>
